import { Space, Divider, Select, Button, Input, Table,  Tooltip, Form,  message, } from 'antd';
import constants from '../../constants/constants';
import {  CheckOutlined, CloseOutlined,FileExcelOutlined } from '@ant-design/icons';
import { useState, useEffect, useContext } from 'react';
import Cookies from 'js-cookie';
import WebLinks from '../../api/WebLinks';
import APIUtils from '../../api/APIUtils';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { GetCustomPriorityLevelIcons, GetPriorityLevelColors, downloadFiles, getPriorityCount } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';

const { Search } = Input;
const { Option } = Select

const YourJobsMaxApps = (props) => {
  //Variable declaration
  const [YourJobsData, setYourJobsData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [multiPriorityUpdate, setMultiPriorityUpdate] = useState([]);
  const [multiMaxAppUpdate, setMultiMaxAppUpdate] = useState([]);
  const [form] = Form.useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(200);
  const [searchedValue, setSearchedValue] = useState("");
  const commonContext=useContext(CommonContext);
  const [buyerId,]=useState(props?.buyerId? props.buyerId:commonContext.common.buyerId);
  const [isClickPost,setIsClickPost]=useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [priorityColorCode,setPriorityColorCode]=useState([]);
  const [priorityCheck,setPriorityCheck]=useState("f");
  const [HiShowPostCode,setHiShowPostCode]=useState(false);
  const [HiShowCountryCode,setHiShowCountryCode]=useState(false);
  const [HiShowState,setHiShowState]=useState(false);
  const [HiShowCompanyName,setHiShowCompanyName]=useState(false);
  const [HiShowAddress,setHiShowAddress]=useState(false);
  const [formSearch] = Form.useForm();
  const [loader,setLoader]=useState(false);
  const [appOptions,setAppOtpions]=useState([]);
  const [priorityFilterValue,setPriorityFilterValue]=useState(null);
  const [maxAppFilterValue,setMaxAppfilterValue]=useState(null);
  const history = useHistory();

  //Function on page load
  useEffect(() => {
    generateOptions();
    getBuyerPrioritylist();
    getBuyerDetails();
    checkParams();
  }, []);
   useEffect(() => {
  }, [form]);

  // check url parameters
  const checkParams= ()=>{
    const url = window.location.href;
    const urlArray =url?.split('?');
    const getParam=urlArray.length>1? urlArray[1]?.split('='):[];
    if(getParam.length>0){
      if(getParam[0]==='id'|| getParam[0]==='keywords'){
        handleSearch(getParam[1])
        formSearch.setFieldsValue({
          searchField:getParam[1]
        })
      }
    }
  };

  //Fetch the jobs upload history for the last 30 days 
  const yourJobsListFetch = async (priorityLevel=null,maxApp=null) => {
    setIsLoading(true);
    resetStateVariable();
    let url;
     url = WebLinks.GetAllYourJobsMaxAppsListing + buyerId;    
    if (priorityLevel && priorityLevel !== "-1") {
      url += "&priorityLevel=" + priorityLevel;
    }
    if (maxApp && maxApp !=="-1"){
      url += "&maxApp=" + maxApp;
    }
    const response = await APIUtils.apiCall('GET', url);
    if (!response.isCatch && response.resultObj) {
      setYourJobsData(response.resultObj.data);
      setHiShowCompanyName(response.resultObj?.hiShowCompanyName);
      setHiShowAddress(response.resultObj?.hiShowAddress);
      setHiShowCountryCode(response.resultObj?.hiShowCountryCode);
      setHiShowPostCode(response.resultObj?.hiShowPostcode );
      setHiShowState(response.resultObj?.hiShowState);
    } else {
      message.error(response?.resultObj?.message);
    }
    setIsLoading(false);
  };
  const getBuyerDetails = async () => {
    setLoader(true);
    const response = await APIUtils.apiCall('GET', WebLinks.GetBuyerDetails + buyerId);
    if (!response.isCatch && response.resultObj?.statusCode === "2000") {
      setIsClickPost(response.resultObj?.data?.clickPost);
      yourJobsListFetch(null,null);
      setLoader(false);
    } else {
      setLoader(false);
    }
  };
  //Reset
  const resetStateVariable=()=>{
    setYourJobsData([]);
    setHiShowCompanyName(false);
    setHiShowAddress(false)
    setHiShowCountryCode(false);
    setHiShowPostCode(false);
    setHiShowState(false);
  };
  //Function to get priority list
  const getBuyerPrioritylist=async()=>{
    let url = WebLinks.GetBuyerPriorityFilters + buyerId;    
    const response = await APIUtils.apiCall('GET', url);
    if (!response.isCatch && response.resultObj) {
      let temppriorityColorCode=[];
      setPriorityCheck(response?.resultObj?.data?.length>5?"t":"f");
      response?.resultObj?.data.forEach(element => {
        let priorityObj={
          value:element.priorityLevel.toString(),
          colorValue:response?.resultObj?.data?.length>5?GetCustomPriorityLevelIcons(element.priorityLevel):GetPriorityLevelColors(element.priorityLevel),
          customName:element.customName,
          prioritycount:getPriorityCount(element.priorityLevel,response?.resultObj?.priorityCount)
        }
        temppriorityColorCode.push(priorityObj);
        setPriorityColorCode(temppriorityColorCode);
      });
    } else {
      setPriorityColorCode([]);
      message.error(response?.resultObj?.message);
    }
  };

  //Function to get the Priority Level to change multiple jobs.
  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => onSelectChange(selectedRowKeys, selectedRows),
  };

  //Function to change the Active button to cross or tick.
  const changeActive = async (rowKey, previousValue) => {
    let tbldata = [...YourJobsData];
    let index = tbldata.findIndex((row) => row.id === rowKey);
    if (index > -1) {
      if (tbldata[index].active === true) {
        tbldata[index].active = false;
      } else {
        tbldata[index].active = true;
      }
      setYourJobsData(tbldata);
    }
    //Api call to update in DB
    let activePayload = null;
    activePayload = {
      jobId: rowKey,
      active: !previousValue,
    }
    const activeResponse = await APIUtils.apiCall('PUT', WebLinks.PutActiveJob, JSON.stringify(activePayload));
    if (activeResponse.isCatch) {
      message.error(message.resultObj.message);
    }
  };

  //Function to Update priority levels
  const UpdatePriorityLevels = async (priorityLevel, selectedIds, multiple = false) => {
    setIsLoading(true);
    let priorityUpdatePayload = selectedIds;
    const priorityLevelResponse = await APIUtils.apiCall("PUT", WebLinks.PutUpdateSinglePriority + "buyerId=" + buyerId + "&PriorityLevelEnd=" + priorityLevel +"&UpdatedByBuyerId="+Cookies.get(constants.COOKIE_LOGGED_BUYER_ID), JSON.stringify(priorityUpdatePayload));
    if (priorityLevelResponse.isCatch) {
      message.error(priorityLevelResponse.resultObj.message);
    } else {
      if (multiple) {
        let tempJobData = [...YourJobsData];
        selectedIds.map((selectedId,index)=>{
          let itemIndex = tempJobData.findIndex(item => item.id === selectedId);
          tempJobData[itemIndex].priority = parseInt(priorityLevel);
        })
        setYourJobsData(tempJobData);
      }
      message.success(priorityLevelResponse.resultObj.message);
    }
    setIsLoading(false);
  }

  //Function to Update Max Apps
  const UpdateMaxApp = async (maxApp, selectedIds, multiple = false) => {
    setIsLoading(true);
    let UpdatePayload = selectedIds;
    const maxAppResponse = await APIUtils.apiCall("PUT", WebLinks.UpdateMaxApps + "buyerId=" + buyerId + "&maxApp=" + maxApp +"&UpdatedByBuyerId="+Cookies.get(constants.COOKIE_LOGGED_BUYER_ID), JSON.stringify(UpdatePayload));
    if (maxAppResponse.isCatch) {
      message.error(maxAppResponse.resultObj.message);
    } else {
      if (multiple) {
        let tempJobData = [...YourJobsData];
        selectedIds.map((selectedId,index)=>{
          let itemIndex = tempJobData.findIndex(item => item.id === selectedId);
          tempJobData[itemIndex].maxApps = maxApp ==="-1"?maxApp:parseInt(maxApp);
        })
        setYourJobsData(tempJobData);
      }
      message.success(maxAppResponse.resultObj.message);
    }
    setIsLoading(false);
  }

  //Function to change the Priority Level of an individual job.
  const singlePriorityChange = async (prioritySelected, id) => {
    let tempJobData = [...YourJobsData];
    let itemIndex = tempJobData.findIndex(item => item.id === id);
    tempJobData[itemIndex].priority = prioritySelected;
    setYourJobsData(tempJobData);
    let tempPriorityList = [];
    tempPriorityList.push(id);
    UpdatePriorityLevels(prioritySelected, tempPriorityList);
  };

    //Function to change the Priority Level of an individual job.
  const singleMaxAppChange = async (maxAppValue, id) => {
    let tempJobData = [...YourJobsData];
    let itemIndex = tempJobData.findIndex(item => item.id === id);
    tempJobData[itemIndex].maxApps = maxAppValue==="-1"?"":maxAppValue;
    setYourJobsData(tempJobData);
    let tempPriorityList = [];
    tempPriorityList.push(id);
    UpdateMaxApp(maxAppValue==="-1"?"":maxAppValue, tempPriorityList);
  };
  //Function to get the priority level for multi-select dropdown
  const allSelectedPriority = (selectedPriority) => {
    setMultiPriorityUpdate(selectedPriority);
  };

    //Function to get the priority level for multi-select dropdown
    const allSelectedMaxApp = (selectedMaxApp) => {
      setMultiMaxAppUpdate(selectedMaxApp);
    };

  //Function to change the Priority Level for multiple jobs.
  const multiplePriorityChange = () => {
    UpdatePriorityLevels(multiPriorityUpdate, selectedRowKeys, true);
  };

  //Function to change the Priority Level for multiple jobs.
  const multipleMaxAppChange = () => {
     UpdateMaxApp(multiMaxAppUpdate, selectedRowKeys, true);
  };

  const handleSearch = (value) => {
    setSearchedValue(value);
  };

  const filterPriority = (value) => {
    setPriorityFilterValue(value);
    yourJobsListFetch(value,maxAppFilterValue);
  }

  const filterMaxApp = (value) => {
    setMaxAppfilterValue(value);
    yourJobsListFetch(priorityFilterValue,value);
  }

const GetNoofDays =(apps,createdOn)=>{
  if (apps === 0) {
    return 0;
  }
  // Check if `createdOn` is a valid date
  const creationDate = new Date(createdOn);
  if (isNaN(creationDate)) {
    return 0; // Handle invalid date gracefully
  }
  const currentDate = new Date();
  const difference = currentDate - creationDate;
  if (difference === 0) {
    return apps; // Avoid division by zero
  }
  const daysDifference = Math.floor(difference / (1000 * 60 * 60 * 24))+1;
  // Ensure `apps` is a valid number before division
  if (isNaN(apps)) {
    return 0; // Handle invalid `apps` value gracefully
  }
  return apps / daysDifference;
};

const handleApplicationCountClick =(record)=>{
  history.push(`/your-jobs-applications/${record.id}`); //${record.id}
};
  // Table columns
  const yourJobsColumns = [
    {
      title: 'id',
      dataIndex: 'id',
      key: 'id',
      hidden: true
    },
    {
      title: 'Active',
      key: 'active',
      dataIndex: 'active',
      align: 'center',
      sorter: (a, b) => (a.active === b.active ? 0 : a.active ? 1 : -1),
      render: (_, record) =>
        record.active === true ? (
          <Button
            icon={<CheckOutlined className="text-xl text-lime-500" />}
            type="text"
            onClick={() => changeActive(record.id, record.active)}
          />
        ) : (
          <Button
            icon={<CloseOutlined className="text-xl text-lime-500" style={{ color: "red" }} />}
            type="text"
            onClick={() => changeActive(record.id, record.active)}
          />
        ),
    },
    {
      title: 'Posted',
      dataIndex: 'posted',
      key: 'posted',
      sorter: (a, b) => moment(a.posted).valueOf() - moment(b.posted).valueOf(),
      render: (text) =>
      (
        <span className='whitespace-nowrap'>{moment(text).format(constants.DateFormat2)}</span>
      )
    },
    {
      title: 'Priority',
      key: 'priority',
      dataIndex: 'priority',
      align: 'center',
      sorter: (a, b) => a.priority - b.priority,
      render: (_, record) => (
        <Select
          onChange={(e) => singlePriorityChange(e, record.id)}
          value={record.priority}
          className='w-14'
          options={priorityCheck==="t"?constants.PriorityConstantList2:constants.PriorityConstantList1}
        />
      ),
    },
    {
      title: 'Apps',
      dataIndex: 'applicationCount',
      key: 'applicationCount',
      hidden: isClickPost,
      sorter: (a, b) => a.applicationCount - b.applicationCount,
      render: (_, record) => 
      (
         <Button type='link' 
         onClick={() => handleApplicationCountClick(record)}>{record.applicationCount || 0}</Button>
      ),
    },
    {
      title: 'Max Apps',
      dataIndex: 'maxApps',
      key: 'maxApps',
      hidden: isClickPost,
      sorter: (a, b) => a.maxApps - b.maxApps,
      render: (_, record) => (
        <Select
          onChange={(e) => singleMaxAppChange(e, record.id)}
          value={record.maxApps?record.maxApps:"-1"}
          className='w-18'
        >
          <Option value="-1">None</Option>
            {appOptions?.map((item=>{
                return(
              <Option value={item.value}>
                {item.label}
              </Option>
                )
              }))}
        </Select>
      ),
    },
    {
      title: 'Apply Clicks',
      dataIndex: 'applyClicks',
      key: 'applyClicks',
      hidden: !isClickPost ,
      sorter: (a, b) => a.applyClicks - b.applyClicks,
    },
    {
      title: 'Job Title',
      dataIndex: 'title',
      key: 'jobTitle',
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: 'Reference',
      dataIndex: 'reference',
      key: 'reference',
      sorter: (a, b) =>{
        const referenceA = parseInt(a.reference.match(/\d+/)[0], 10);
        const referenceB = parseInt(b.reference.match(/\d+/)[0], 10);
    
        return referenceA - referenceB;
      },
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
      hidden: !HiShowAddress,
      sorter: (a, b) => a.address.localeCompare(b.address),
    },
    {
      title: 'Location',
      dataIndex: 'place',
      key: 'place',
      sorter: (a, b) => a.place.localeCompare(b.place),
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
      hidden: !HiShowState,
      sorter: (a, b) => a.state.localeCompare(b.state),
    },
    {
      title: 'Postcode',
      dataIndex: 'postcode',
      key: 'postcode',
      hidden: !HiShowPostCode,
      sorter: (a, b) =>{
        if (a.postcode === '-') return -1; // '-' comes first
        if (b.postcode === '-') return 1; // '-' comes first
        return a.postcode.localeCompare(b.postcode);
      },
    },
    {
      title: 'Country',
      dataIndex: 'countryCode',
      key: 'countryCode',
      hidden: !HiShowCountryCode,
      sorter: (a, b) =>{
        if (a.countryCode === '-') return -1; // '-' comes first
        if (b.countryCode === '-') return 1; // '-' comes first
        return a.countryCode.localeCompare(b.countryCode);
      },
    },
    {
      title: 'countryCode',
      dataIndex: 'countryCode',
      key: 'countryCode',
      hidden: true,
    },
    {
      title: 'Company',
      dataIndex: 'companyName',
      key: 'companyName',
      hidden: !HiShowCompanyName,
      sorter: (a, b) => a?.companyName?.localeCompare(b?.companyName),
    },
  ];
  // Table end
  const filteredDataSource = YourJobsData.filter((record) =>{
    if (yourJobsColumns.some((column) => {
      const dataIndex = column.dataIndex;
      if (dataIndex) {
        const cellValue = record[dataIndex];
        // Handle custom rendering for '/Day' column
        if (dataIndex === 'applicationCount' && column.title === '/Day') {
          const cellValueString = GetNoofDays(record.applicationCount, record.posted).toString().toLowerCase();
          if (cellValueString.includes(searchedValue.toLowerCase())) {
            return true;
          }
        }else if(dataIndex === 'id'){
          const ids = searchedValue.split(',').map(id => id?.trim()).filter(id => id !== '');
          if(ids.some(id => record[dataIndex].toString().toLowerCase().includes(id?.toLowerCase()))){
            return true;
          }else{
            return false;
          }
        } 
        else {
          // Handle standard columns
          const cellValueString = cellValue && cellValue.toString().toLowerCase();
          if (cellValueString && cellValueString.includes(searchedValue.toLowerCase())) {
            return true;
          }
        }
      }
      return false; // Skip undefined or null values
    })) {
      return true; // If any column has a match, include the record
    }
    return false; // Skip records with no matches in any column
  });


	//Function to download as excel
	const downloadFile = () => {
		setLoader(true)
    let url;
    url = WebLinks.DownloadMaxAppReport + buyerId;    
   if (priorityFilterValue && priorityFilterValue !== "-1") {
     url += "&priorityLevel=" + priorityFilterValue;
   }
   if (maxAppFilterValue && maxAppFilterValue !=="-1"){
     url += "&maxApp=" + maxAppFilterValue;
   }
		downloadFiles(url,"MaxAppsReport.xlsx");
    setTimeout(() => {
				setLoader(false)
		}, 3000);
	};


  const generateOptions = () => {
    const options = [];  
    // Multiples of 5 from 5 to 200
    for (let i = 5; i <= 200; i += 5) {
      options.push({ value: i, label: i });
    } 
    // Multiples of 10 from 210 to 500
    for (let i = 210; i <= 500; i += 10) {
      options.push({ value: i, label: i });
    }
    setAppOtpions(options);
  };

  return (
    <div>
      <div className="flex justify-end mb-3 text-xs">
            <Space wrap>
            <label>
            <strong>{constants.PriorityLevels}</strong>
          </label>
            {priorityColorCode?.map((item=>{
              return(
                <Space>
                <div className={item.colorValue}></div>
                <span>{item.customName} [{item.prioritycount}]</span>
              </Space>
              )
            }))}
            </Space>
          </div>
      <div className="flex justify-between items-center gap-1">
        <Space>
          <div className="uppercase font-bold text-xl">Your Jobs- Max Apps</div>
        </Space>
      </div>
      <Divider className="my-3" />
      <div className="flex flex-wrap justify-between items-center gap-1 mb-3">
        <Space wrap>
        <span>Update all selected jobs:</span>
          <Space.Compact>
          <Select
            className="w-[65vw] md:w-40"
            defaultValue="-1"
            placeholder="Select App Count "
            onChange={allSelectedMaxApp}
          >
            <Option value="-1">None</Option>
            {appOptions?.map((item=>{
                return(
              <Option value={item.value}>
                {item.label}
              </Option>
                )
              }))}
          </Select>
          <Button type="primary" onClick={() => multipleMaxAppChange()}>Update</Button>
          </Space.Compact>
        </Space>
        <Select
          onChange={filterPriority}
          defaultValue={"-1"}
          placeholder="Please select"
          className="w-full md:w-60"
        >
          <Option value="-1">
            <Space>
              Priority Filter - Show All
            </Space>
          </Option>
          {priorityColorCode?.map((item=>{
                return(
              <Option value={item.value}>
                   <Space>
                     <div className={item.colorValue}></div>
                     {item.customName}
                   </Space>             
              </Option>
                )
              }))}
        </Select>
        <Select
            className="w-[65vw] md:w-60"
            defaultValue="-1"
            placeholder="Select App Count "
            onChange={filterMaxApp}
          >
            <Option value="-1">Max App Filter - None</Option>
            {appOptions?.map((item=>{
                return(
              <Option value={item.value}>
                {item.label}
              </Option>
                )
              }))}
          </Select>
        <Form
         form={formSearch}
        >
          <Form.Item name="searchField"  className='mb-0'>
            <Search
              placeholder="Search"
              allowClear
              onSearch={(e) => handleSearch(e)}
              onChange={(e) => { handleSearch(e.target.value);}}
              enterButton
              className="w-full md:w-60"
            />
          </Form.Item>
        </Form>
        <Tooltip placement='right' title="Download as Excel">
            <Button loading={loader}  onClick={() => downloadFile()} className="bg-green-800 text-white hover:!text-white hover:!border-green-500" icon={<FileExcelOutlined />}></Button>
        </Tooltip>
      </div>
      <div className="flex flex-wrap justify-between items-center gap-1 mb-3">
        <Space wrap>
          
        </Space>

      </div>
      <div className="overflow-x-auto">
        <Table
          loading={isLoading}
          size='small'
          rowSelection={{
            type: 'checkbox',
            ...rowSelection,
            selectedRowKeys: selectedRowKeys
          }}
          rowKey="id"
          columns={yourJobsColumns}
          dataSource={filteredDataSource}
          // onChange={onChangeJobTable}
          pagination={{
            total: filteredDataSource?.length || 0,
            showSizeChanger: true,
            pageSizeOptions: ["200", "500", "1000", "2000"],
            defaultPageSize: 200,
            onChange: (page,pageSize) => {setCurrentPage(page); setPageSize(pageSize)},
            // current: currentPage,
          }}
          footer={(paginationData) =>
            `Showing ${Math.min(((currentPage - 1) * pageSize + 1), filteredDataSource?.length || 0)} to ${Math.min((currentPage * pageSize), filteredDataSource?.length || 0)} of ${filteredDataSource?.length || 0} entries`
          }
        />
      </div>
    </div>
  );
};

export default YourJobsMaxApps;